import { render, staticRenderFns } from "./WebWorkflowAntragPause.vue?vue&type=template&id=0671b9ad&scoped=true"
import script from "./WebWorkflowAntragPause.vue?vue&type=script&lang=ts"
export * from "./WebWorkflowAntragPause.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671b9ad",
  null
  
)

export default component.exports